import React from 'react';
import { FileText } from 'lucide-react';

const HomeworkFilters = ({ filter, setFilter, searchTerm, setSearchTerm, statusCounts, totalCount }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm p-6 border">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex-1">
          <div className="relative">
            <FileText className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              placeholder="Search homework by subject..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
            />
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          {[
            { key: 'all', label: 'All', count: totalCount },
            { key: 'Assigned', label: 'Assigned', count: statusCounts['Assigned'] || 0 },
            { key: 'In Progress', label: 'In Progress', count: statusCounts['In Progress'] || 0 },
            { key: 'Completed', label: 'Completed', count: statusCounts['Completed'] || 0 }
          ].map(({ key, label, count }) => (
            <button
              key={key}
              onClick={() => setFilter(key)}
              className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 flex items-center gap-2 ${
                filter === key
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:shadow-sm'
              }`}
            >
              <span>{label}</span>
              <span className={`px-2 py-1 text-xs rounded-full ${
                filter === key ? 'bg-blue-500' : 'bg-gray-300'
              }`}>
                {count}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeworkFilters;